module.exports = __webpack_public_path__ + "static/media/photo-7.e2ece3ad.webp";